const ordinalSuffix = (day) => {
    if (day % 10 === 1 && day !== 11) return 'st';
    if (day % 10 === 2 && day !== 12) return 'nd';
    if (day % 10 === 3 && day !== 13) return 'rd';
    return 'th';
};

// Single source of truth for how an absolute calendar date is shown to the
// user across the app (plan headings, activity lists/details, graph
// tooltips, etc.) - "18th Sep 2026". Accepts a Date, an ISO date/datetime
// string, or anything else `new Date()` understands.
export const formatDisplayDate = (dateInput) => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const day = date.getDate();
    const month = date.toLocaleDateString('en-GB', { month: 'short' });
    const year = date.getFullYear();
    return `${day}${ordinalSuffix(day)} ${month} ${year}`;
};
